export default "__VITE_ASSET__K4ycbdZI__"